<div class="container col-sm-12 col-md-6 offset-md-1">
    <p-toast position="top-right"></p-toast>

    <div class="form-back  h4 my-4">
        <a [routerLink] = "['/', this.slug, 'doctor', 'admin', 'coupons']">&#8592; Back</a>
    </div>
    <div class="doc-reg-heading font-weight-bold text-center">
        <h2>
            Add Referral Discount Code
        </h2>
    </div>
    <form accept-charset="UTF-8" id="discount_form" ngNativeValidate>
        <div class="formdiv text-dark p-4">

            <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                    <label class="col-sm-12 font-weight-bold" for="discounttype">Discount Type*</label>
                    <select class="custom-select custom-select rounded-pill" (change)="setPrefix(mySelect.value)"
                        required name="refferalTypeId" #mySelect>
                        <option [value]=null [disabled]="true" [selected]="true">Select from the dropdown</option>
                        <option *ngFor="let item of refferalTypes "
                            [value]="item.id+'$-$@@$@@$#@$@$@$@-@'+item.referral_prefix">{{item.referral_type}}</option>
                    </select>

                </div>
            </div>

            <div class="form-group row">

                <div class="col-md-12 col-sm-12">
                    <label class="col-sm-12 font-weight-bold" for="discountcode">Discount Code*</label>
                    <input type="text" style="width: 50%;display: inline-block;" class="form-control rounded-pill"
                        id="discountprefix" name="discountprefix" aria-describedby="discountcode"
                        placeholder="Discount prefix" [(ngModel)]="discountprefix" disabled>
                    <input type="text" style="width: 50%;display: inline-block;" class="form-control rounded-pill"
                        id="discountcode" name="discountcode" aria-describedby="discountcode"
                        placeholder="Discount Code" [(ngModel)]="discountCode" required>
                </div>
            </div>

            <!-- <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                <label class="col-sm-12 font-weight-bold" for="appliesto">Applies To</label>
                    <select name="appliesto" class="custom-select custom-select rounded-pill" disabled>
                        <option value=null disabled selected>Select from the dropdown</option>

                    </select>
                </div>
            </div> -->

            <div class="form-group row">
                <div class="col-sm-12 col-md-6">
                    <label class="col-sm-12 font-weight-bold" for="startDate">Start Date*</label>
                    <p-calendar id="startDate" class="notranslate" [(ngModel)]="startDate" name="startDate" [required]="true"
                        [style]="{'width':'100%'}" [inputStyle]="{'width':'100%','border-radius':'50rem'}"
                        placeholder="Expiry Date (MM/DD/YYYY)" dateFormat="dd/mm/yy" showTime="true" hourFormat="12"
                        [minDate]="minStartDateValue" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="1900:2099" [showIcon]="false" [readonlyInput]="true" placeholder="dd/mm/yyyy" required>
                    </p-calendar>

                </div>

                <div class="col-sm-12 col-md-6">
                    <label class="col-sm-12 font-weight-bold" for="endDate">Expiry Date*</label>
                    <p-calendar id="endDate" [(ngModel)]="endDate" class="notranslate" name="endDate" [required]="true"
                        [style]="{'width':'100%'}" [inputStyle]="{'width':'100%','border-radius':'50rem'}"
                        placeholder="Expiry Date (MM/DD/YYYY)" dateFormat="dd/mm/yy" showTime="true" hourFormat="12"
                        [minDate]="minEndDateValue" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                        [showIcon]="false" [readonlyInput]="true" placeholder="dd/mm/yyyy">
                    </p-calendar>

                </div>

            </div>

            <div class="form-group row">

                <div class="col-md-6 col-sm-12">
                    <label class="col-sm-12 font-weight-bold" for="discountusage">Discount Usage*</label>
                  <!--  <div class="form-check ml-d-1 ml-sm-0"> -->
                        <!-- <input class="form-check-input" type="number" value=true id="discountusage"
                            [(ngModel)]="discountusage" name="discountusage"> -->
                        <input type="number" style="width: 100%;display: inline-block;" class="form-control rounded-pill"
                            id="discountusage" name="discountusage" aria-describedby="discountusage"
                            placeholder="Max Count" [(ngModel)]="discountusage" required>
                        <div class="form-check ml-d-1 ml-sm-0">
                            <label class="form-check-label" for="discountusage">
                                max coupon to create?
                            </label>
                        </div>
                 <!--   </div> -->
                </div>

            <!--    <div class="col-md-6 col-sm-12">
                    <label class="col-sm-12 font-weight-bold" for="discountusage">Discount Usage</label>
                    <div class="form-check ml-d-1 ml-sm-0">
                         <input class="form-check-input" type="number" value=true id="discountusage"
                            [(ngModel)]="discountusage" name="discountusage">
                        <input type="number" style="width: 100%;display: inline-block;" class="form-control rounded-pill"
                            id="discountusage" name="discountusage" aria-describedby="discountusage"
                            placeholder="Max Count" [(ngModel)]="discountusage" required>
                        <label class="form-check-label" for="discountusage">
                            Max coupon to create?
                        </label>
                    </div>
                </div>
            -->

                <div class="col-sm-12 col-md-6">
                    <div class="form-check ml-md-1 ml-sm-0">
                        <!-- <input class="form-check-input" type="radio" name="discountType" id="discountpercent"
                            value="option1"> -->
                        <label class="form-check-label font-weight-bold" for="discountpercent">
                            Discount Percent*
                        </label>
                    </div>
                    <input type="text" class="form-control rounded-pill mt-2" id="discounttypetext"
                        name="discountPercent" aria-describedby="discounttypetext" placeholder="Enter % Amount"
                        [(ngModel)]="discountPercent" required min="1" max="100">
                </div>



                <!-- <div class="col-sm-12 col-md-6">
                    <label class="col-sm-12 font-weight-bold" for="expirydate">Expiry Date*</label>
                    <p-calendar id="dob" [(ngModel)]="dob" name="dob" [required]="true"
                         [style]="{'width':'100%'}"
                        [inputStyle]="{'width':'100%','border-radius':'50rem'}" placeholder="Expiry Date (MM/DD/YYYY)"
                        dateFormat="dd/mm/yy" showTime="true" hourFormat="12"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099" [showIcon]="false" [minDate]="minDateValue" [readonlyInput]="true"
                        placeholder="dd/mm/yyyy">
                    </p-calendar>

                </div> -->

            </div>

            <!-- <div class="form-group row"> -->

            <!-- <div class="col-sm-12 col-md-6">
                    <div class="form-check ml-md-1 ml-sm-0">
                        <input class="form-check-input" type="radio" name="discountType" id="discountpercent" value="option1">
                        <label class="form-check-label font-weight-bold" for="discountpercent">
                        Discount Percent*
                        </label>
                    </div>
                        <input type="text" class="form-control rounded-pill mt-2" id="discounttypetext" name="discountPercent"
                        aria-describedby="discounttypetext" placeholder="Enter % Amount" [(ngModel)]="discountPercent" required min="1" max="100">
                </div> -->

            <!-- <div class="col-sm-12 col-md-6">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="discountType" id="discountamount" value="option2
                        " disabled>
                        <label class="form-check-label font-weight-bold" for="discountamount">
                        Discount Amount
                        </label>
                    </div>
                        <input type="text" class="form-control rounded-pill mt-2" id="discountamounttext" name="discountamounttext"
                        aria-describedby="discountamounttext" placeholder="Enter Flat Amount" disabled>
                </div> -->
            <!-- </div> -->

            <div class="form-group row">
                <div class="col-md-6 col-sm-12">

                    <div class="form-check ml-d-1 ml-sm-0 mt-md-5">
                        <input class="form-check-input" type="checkbox" value=true id="discountglobal"
                            [(ngModel)]="isgblobal" name="isgblobal">
                        <label class="form-check-label font-weight-bold" for="discountglobal">
                            Is Discount Code Global?
                        </label>
                    </div>
                </div>

                <div *ngIf="!isgblobal" class="col-md-6 col-sm-12">
                    <label class="col-sm-12 font-weight-bold" for="country">Country</label>
                    <select class="custom-select custom-select rounded-pill" [(ngModel)]="selectedCountry"
                        name="selectedCountry">
                        <option value=null disabled selected>Select from the dropdown</option>
                        <option *ngFor="let item of countries " [value]="item.id">{{item.country_name}}</option>

                    </select>
                </div>
                <!-- <p *ngIf="e != null" style="color: red; text-align: center;font-weight: bold;margin-left: 50px;">{{e}}</p> -->
            </div>

            <div class="form-group row" *ngIf="false">
                <div class="col-md-6 col-sm-12">

                    <div class="form-check ml-d-1 ml-sm-0">
                        <input class="form-check-input" type="checkbox" value="" id="isactive">
                        <label class="form-check-label font-weight-bold" for="isactive">
                            Is Active?
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <div class="row text-center">
            <button (click)="prev()" type="submit"
                class="btn btn-primary font-weight-bold bg-white text-dark rounded-pill ml-5 pl-5 pr-5">
                Cancel
            </button>
            <button type="submit" (click)="createDiscountCode()"
                class="btn btn-primary font-weight-bold text-white rounded-pill ml-5 pl-5 pr-5">
                Create
            </button>
            <span *ngIf="loading">
                <p-progressSpinner [style]="{width: '30px', height: '30px'}" styleClass="custom-spinner">
                </p-progressSpinner>
            </span>
            <!-- <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 2rem ;margin-left: 160px;"></i> -->
            <p *ngIf="e != null" style="color: red; text-align: center;font-weight: bold;margin-left: 50px;">{{e}}</p>
        </div>

    </form>

</div>
